import React, { Fragment, useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import _ from 'lodash';
import MainLayout from '../components/layouts/MainLayout';
import DoorlockDetail from '../components/views/doorlocks/DoorlockDetail';
import { ResponseFailModal } from '../components/modal/Response';
import Spin from '../components/Spin';
import * as api from '../api';

const DoorlockDetailContainer = ({
  history,
  match,
}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenApiErrorModal, setIsOpenApiErrorModal ] = useState(false);
  const [ apiErrorMessage, setApiErrorMessage ] = useState('');
  const [ apiErrorSubMessage, setApiErrorSubMessage ] = useState('');
  const doorlockId = match.params.id;
  const [ selectedDoorlockItem, setSelectedDoorlockItem ] = useState({
    name: '',
    type: '',
    serial: '',
    buildingName: '',
    floorName: '',
    status: '',
    fwVersion: '',
    fwBattery: '',
    fwType: '',
    createdAt: '',
    updatedAt: '',
  });
  const [ doorlockLogListTotal, setDoorlockLogListTotal ] = useState(0);
  const [ doorlockLogListItems, setDoorlockLogListItems ] = useState([]);
  const [ doorlockLogListPaginationItem, setDoorlockLogListPaginationItem ] = useState({
    offset: 0,
    limit: 50,
  });
  const [ doorlockLogListSortItem, setDoorlockLogListSortItem ] = useState({
    sort: 'log_id',
    order: 'desc',
  });
  const [ doorlockLogListFilterItem, setDoorlockLogListFilterItem ] = useState({
    logType: '',
  });
  const [ doorlockBatteryLogListItems, setDoorlockBatteryLogListItems ] = useState([]);
  const [ doorlockBatteryLogListFilterItem, setDoorlockBatteryLogListFilterItem ] = useState({
    startAt: moment().subtract(1, 'year').startOf('day').toDate(),
    endAt: moment().endOf('day').toDate(),
  });

  const moveToListPage = useCallback(() => {
    history.push('/doorlock');
  }, [history]);

  const selectDoorlock = useCallback(async () => {
    try {
      const res = await api.selectDoorlock({doorlockId});
      setSelectedDoorlockItem({
        name: res.data.name,
        type: res.data.type,
        serial: res.data.dl_serial,
        buildingName: res.data.building_name,
        floorName: res.data.floor_name,
        status: res.data.status,
        fwVersion: res.data.fw_version,
        fwBattery: res.data.fw_battery,
        fwType: res.data.fw_type,
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
      });
    } catch (error) {
      setApiErrorMessage('도어락 상세 조회 실패');
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
    }
  }, [doorlockId]);

  const listDoorlockLog = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.listDoorlockLog({doorlockId, ...doorlockLogListFilterItem, ...doorlockLogListSortItem, ...doorlockLogListPaginationItem});
      setDoorlockLogListTotal(res.data.total);
      setDoorlockLogListItems(res.data.items);
    } catch (error) {
      setApiErrorMessage('도어락 로그 조회 실패');
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  }, [doorlockId, doorlockLogListFilterItem, doorlockLogListSortItem, doorlockLogListPaginationItem]);

  const listDoorlockBatteryLog = useCallback(async () => {
    try {
      const res = await api.listDoorlockBatteryLog({
        doorlockId,
        startAt: doorlockBatteryLogListFilterItem.startAt ? moment(doorlockBatteryLogListFilterItem.startAt).startOf('day').utc().format() : '',
        endAt: doorlockBatteryLogListFilterItem.endAt ? moment(doorlockBatteryLogListFilterItem.endAt).endOf('day').utc().format(): '',
      });
      setDoorlockBatteryLogListItems(_.sortBy(res.data, ['created_at']));
    } catch (error) {
      setApiErrorMessage('도어락 배터리 로그 조회 실패');
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
    }
  }, [doorlockId, doorlockBatteryLogListFilterItem]);

  useEffect(() => {
    try {
      if (doorlockId) {
        selectDoorlock();
        listDoorlockLog();
        listDoorlockBatteryLog();
      }
    } catch (error) {
      throw error;
    }
  }, [doorlockId, selectDoorlock, listDoorlockLog, listDoorlockBatteryLog]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={moveToListPage}
        ContentBody={(
          <Fragment>
            <DoorlockDetail
              doorlockId={doorlockId}
              selectedDoorlockItem={selectedDoorlockItem}
              doorlockLogListTotal={doorlockLogListTotal}
              doorlockLogListItems={doorlockLogListItems}
              doorlockBatteryLogListItems={doorlockBatteryLogListItems}
              doorlockLogListFilterItem={doorlockLogListFilterItem}
              doorlockLogListSortItem={doorlockLogListSortItem}
              doorlockLogListPaginationItem={doorlockLogListPaginationItem}
              doorlockBatteryLogListFilterItem={doorlockBatteryLogListFilterItem}
              setDoorlockLogListFilterItem={setDoorlockLogListFilterItem}
              setDoorlockLogListSortItem={setDoorlockLogListSortItem}
              setDoorlockLogListPaginationItem={setDoorlockLogListPaginationItem}
              setDoorlockBatteryLogListFilterItem={setDoorlockBatteryLogListFilterItem}
              selectDoorlockApi={selectDoorlock}
              moveToListPage={moveToListPage}
              history={history}
            />
            <ResponseFailModal
              isOpen={isOpenApiErrorModal}
              toggle={() => setIsOpenApiErrorModal(!isOpenApiErrorModal)}
              message={apiErrorMessage}
              subMessage={apiErrorSubMessage}
            />
          </Fragment>
        )}
      />
    </Fragment>
  );
}

export default DoorlockDetailContainer;